<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Sample', apiMethod: 'Samples', form: () => import('../forms/SampleForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                    { text: 'Sample Tests', value: 'sampleTestId', isCard: true, table: () => import('../tables/SampleTestsTable') },
                ],
                mainForm: () => import('../forms/SampleForm'),
                claimName: 'Samples',
                apiMethod: 'Samples',
            }
        }
    };
</script>
